var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class AlfatronMuheGen2 {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'r power!',
                next: /power\s*(on|off)/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`r fw version!`, /MCU\s+APP\s*:V([\d\.]+)/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`r power!`, /power\s+(on|off)/i, tags);
                return match[1].toLowerCase() === 'on';
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`s power ${power ? '1' : '0'}!`, /power\s+(on|off)/i, tags, { sendTimeoutMs: 6000 } // ack upon power on takes longer
                );
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 1000);
                // Takes about 20 seconds after power up before it accepts commands again.
                this.framework.suspend(power ? 20000 : 1000);
                return match[1].toLowerCase() === 'on';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`r av out ${key}!`, /input\s+(\d+)\s+->\s+output\s+(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove leading 0's
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`s in ${value} av out ${key}!`, /input\s+(\d+)\s+->\s+output\s+(\d+)/i, tags);
                return parseInt(match[1], 10).toString(); // remove any leading 0's
            }),
            asyncHandlers: [
                {
                    regExp: /input\s+(\d+)\s+->\s+output\s+(\d+)/i,
                    callback: (match) => {
                        const value = parseInt(match[1], 10).toString();
                        const key = parseInt(match[2], 10).toString();
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
            ],
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power', 'videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
AlfatronMuheGen2.driverType = 'socketDriver';
AlfatronMuheGen2.key = '-NFEUdp98b8A04jn3nAx';
AlfatronMuheGen2.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
AlfatronMuheGen2.socketOptions = [
    Object.assign(Object.assign({}, AlfatronMuheGen2.baseSocketOptions), { port: 8000 }),
    Object.assign(Object.assign({}, AlfatronMuheGen2.baseSocketOptions), { port: 4999 }),
];
